module.exports = __webpack_public_path__ + "static/media/miniwave-policie-purple.6abe4295.svg";